import axios from "axios";
import { createClient } from "@supabase/supabase-js";

export const API_BASE = import.meta.env.VITE_SUPABASE_URL;
const API_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY; // Supabase anon key

export const supabase = createClient(API_BASE, API_KEY);

export const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
    apikey: API_KEY,
    Authorization: `Bearer ${API_KEY}`,
  },
});

// Helper to add Authorization dynamically
export function getAuthHeaders(token?: string) {
  const bearer = token || API_KEY;
  return {
    Authorization: `Bearer ${bearer}`,
    apikey: API_KEY,
    "Content-Type": "application/json",
  };
}



